import React from "react";
import { Loader2, Siren, MessageSquarePlus } from "lucide-react";
import { POS_COLORS, LEVEL_COLOR } from "./shared";

export default function DesperationTab({ desperation, draftPitch }) {
  if (desperation === null) {
    return <div className="card-bordered p-12 flex justify-center"><Loader2 className="w-6 h-6 spin text-[var(--accent)]" /></div>;
  }
  return (
    <>
      <div className="text-sm text-[var(--text-2)] mb-3">
        Ranked by <span className="text-white">positional need</span> — each team's total asset value & premium-talent at every position vs the rest of the league, plus any injuries dragging a position down. Lowest at a position = the best manager to sell that position to.
      </div>
      {(desperation.teams || []).every(t => t.desperation_score === 0) && (
        <div className="card-bordered p-5 mb-3 text-sm text-[var(--text-3)]" data-testid="desperation-calm">
          Rosters look balanced across positions right now — no team is meaningfully short on value anywhere. (Mid-draft, this fills in as teams complete their rosters.)
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {desperation.teams.map(t => (
          <div key={t.roster_id} className="card-bordered p-5" style={{ borderLeft: `2px solid ${LEVEL_COLOR[t.level]}` }} data-testid={`desp-${t.roster_id}`}>
            <div className="flex items-center justify-between mb-2">
              <div className="font-display font-bold text-lg">{t.manager}</div>
              <div className="text-[10px] tracking-widest uppercase font-mono px-2 py-0.5 rounded-sm border border-[var(--border)]" style={{ color: LEVEL_COLOR[t.level] }}>{t.level}</div>
            </div>
            {t.needs.length > 0 && (
              <div className="flex flex-wrap gap-1.5 mb-2">
                {t.needs.map(n => <span key={n} className="text-[10px] tracking-wider uppercase px-2 py-0.5 rounded-sm bg-black/40 border border-[var(--border)]" style={{ color: POS_COLORS[n] || "var(--text-2)" }}>Needs {n}</span>)}
              </div>
            )}
            {t.alerts.length > 0 ? (
              <ul className="space-y-1 mb-3">
                {t.alerts.map((a, i) => (
                  <li key={i} className="text-xs text-[var(--text-2)] flex items-start gap-1.5"><Siren className="w-3 h-3 mt-0.5 shrink-0" style={{ color: LEVEL_COLOR[t.level] }} />{a}</li>
                ))}
              </ul>
            ) : <div className="text-xs text-[var(--text-3)] mb-3">No notable positional weaknesses vs the league.</div>}
            {t.desperation_score > 0 && (
              <button onClick={() => draftPitch({ roster_id: t.roster_id, manager: t.manager })} className="btn-primary w-full text-xs inline-flex items-center justify-center gap-2" data-testid={`desp-pitch-${t.roster_id}`}>
                <MessageSquarePlus className="w-3.5 h-3.5" /> Exploit with AI pitch
              </button>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
